export const MemesDetailsPoint = {
  pageName: 'MemesDetails',
  pageId: '25105',
  pagePath: '/marketing/Memes/Details',
  common: {
    source: 2,
    typeId: 'opinions_market_pc_v2',
  },
  button: {},
  card: {},
};
